import { motion } from "framer-motion";
import { CHAPTERS } from "@/data/forge";

export default function Chapters() {
  return (
    <section data-testid="forge-system-section" className="py-10 md:py-14">
      <div className="mx-auto w-[min(1180px,calc(100%-32px))]">
        <div className="flex flex-wrap items-end justify-between gap-5 mb-10">
          <h2 className="headline text-3xl sm:text-4xl lg:text-5xl">
            <span className="text-white">Create </span>
            <span className="text-forge">Move </span>
            <span className="text-ember">Repeat</span>
          </h2>
          <p className="text-sm text-white/45 max-w-[420px]">
            Five moves. Turn your ideas into workouts, your workouts into Pouches, and your Pouches
            into a path you share.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
          {CHAPTERS.map((chapter, i) => (
            <motion.article
              key={chapter.n}
              data-testid={`chapter-${chapter.title.toLowerCase()}`}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
              className="group relative rounded-2xl border border-white/10 bg-[#0b0b0c] p-5 hover:border-forge/45 hover:-translate-y-1 transition-[transform,border-color] duration-400"
            >
              <span className="absolute top-[6px] left-5 right-5 h-[2px] rounded-full ember-line origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" />
              <div className="display text-[10px] tracking-[0.35em] text-forge mb-3">{chapter.n}</div>
              <h3 className="headline text-2xl mb-2 group-hover:text-ember transition-colors">{chapter.title}</h3>
              <p className="text-[12px] text-white/45 leading-relaxed">{chapter.copy}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
